/*
 * SPDX-FileCopyrightText: 2020 CERN.
 * SPDX-License-Identifier: MIT
 */

import { ResultsGridItem, ResultsListItem } from "./components";

export default {
  "ResultsList.item": ResultsListItem,
  "ResultsGrid.item": ResultsGridItem,
};
